var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnbekEcoLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9688 33.5C26.0814 33.5 33.4688 26.1127 33.4688 17C33.4688 7.8873 26.0814 0.5 16.9688 0.5C7.85605 0.5 0.46875 7.8873 0.46875 17H16.9688V33.5Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9688 33.5C26.0814 33.5 33.4688 26.1127 33.4688 17C33.4688 7.8873 26.0814 0.5 16.9688 0.5C7.85605 0.5 0.46875 7.8873 0.46875 17H16.9688V33.5Z",
    fill: "url(#paint0_angular_5169_30567)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_5169_30567",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.9687 17) rotate(90) scale(16.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40109,
    stopColor: "#FFBD81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.760417,
    stopColor: "#FF9D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#FF7E00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnbekEcoLogo);
export default __webpack_public_path__ + "static/media/enbek-eco-logo.ab319ce679a7fdd4ff3aa2863606144d.svg";
export { ForwardRef as ReactComponent };